/* eslint-disable no-restricted-imports */
import {createRoot} from 'react-dom/client'
import {createElement} from 'react'
import {UIGameSettings} from './core/UIGameSettings'
import UIGame from './core/UIGame'
import {flushSync} from 'react-dom'
import {GameSettings} from '@colonist/game-base-types'
import {UIGameManager} from '../../../code/client/shared/scripts/ui_game/UIGameManager'

export const renderUIGame = (containerId: string = 'ui-game-container') => {
    let retries = 5

    const renderElement = () => {
        const rootElement = document.getElementById(containerId)
        if(rootElement) {
            const root = createRoot(rootElement)
            flushSync(() => {
                root.render(createElement(UIGame))
            })
        } else {
            if(retries > 0) {
                retries -= 1
                setTimeout(() => {
                    renderElement()
                }, 5000)
            }
        }
    }

    renderElement()
}
export const renderUIGameSettings = (props: {
    gameManager: UIGameManager
    gameSettings: GameSettings
}) => {
    const {gameManager} = props
    let container = document.getElementById('ui-game-settings-container') as HTMLDivElement | null
    if(!container) {
        container = document.createElement('div')
        container.id = 'ui-game-settings-container'
        container.style.position = 'absolute'
        container.style.top = '50%'
        container.style.transform = 'translate(0, -50%)'
        container.style.zIndex = '2'
        container.style.display = 'none'
        document.body.appendChild(container)
    }

    const resizeGameContainer = () => {
        container.style.left = gameManager.canvasController.app.view.style.left
        container.style.width = (gameManager.canvasController.appW - gameManager.canvasController.chatWidth) + 'px'
        container.style.height = gameManager.canvasController.appH + 'px'
    }

    window.addEventListener('resize', () => {
        resizeGameContainer()
    })
    resizeGameContainer()

    const root = createRoot(container)
    // TODO: Remove flushSync when everything migrated to React
    flushSync(() => {
        root.render(createElement(UIGameSettings, props))
    })
}
